export default "__VITE_ASSET__aada4830__"